export default __webpack_public_path__ + "static/media/cancel-icon-primary.41483dc9.svg";